// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1u1rh","content":"GlobalSearch_content__1Bkbi"};